var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15.1302V9.37518L24.9982 6.49768L21.9521 8.25004L20.0018 7.12754V3.62018L15 0.742676L9.99823 3.62018V7.12842L8.04785 8.25092L5.00177 6.49856L0 9.37518V15.1293L3.04962 16.8834V19.1319L0 20.8869V26.6411L5.00177 29.5186L8.06198 27.7583L9.99823 28.872V32.3802L15 35.2577L20.0018 32.3802V28.872L21.938 27.7583L24.9982 29.5186L30 26.6411V20.8869L26.9504 19.1328V16.8843L30 15.1302ZM19.9965 20.8869V24.3829L18.0496 25.5027L15 23.7486L11.9504 25.5027L10.0035 24.3829V20.8869L6.95391 19.1328V16.8843L10.0035 15.1302V11.6175L11.9504 10.4977L15 12.2518L18.0496 10.4977L19.9965 11.6175V15.1302L23.0461 16.8843V19.1328L19.9965 20.8869Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC6);
export default __webpack_public_path__ + "static/media/c6.1815929816eeb94c7424bbafa5362546.svg";
export { ForwardRef as ReactComponent };